import React from "react";
import Slider from "react-slick";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";
import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";

const ExtendedCardsBlock = ({ doc }) => {
  const { header, description, link, link_text } = doc?.primary || {};

  const carouselConfig = {
    dots: false,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrows: true,
        },
      },
    ],
  };

  return (
    <div className="py-5 py-2xl-5 extended-cards-slice prismic-slice">
      <div className="container container-width">
        {checkContentPresence(header) && (
          <div className="sns-h2 text-center extended-cards-slice-title same-size-title">
            {textResolver(header)}
          </div>
        )}
        {checkContentPresence(description) && (
          <div className="mt-3 mt-2xl-3 sns-h4 text-center extended-cards-slice-description">
            {textResolver(description)}
          </div>
        )}
        <div className="mt-5 pt-md-3 pt-2xl-3 extended-cards-slice-blocks-holder">
          <Slider {...carouselConfig}>
            {doc?.items?.map(
              ({ image, image_header, image_description, image_link, image_link_text }, index) => (
                <div className="mb-4 mb-md-0 text-center extended-cards-block" key={index}>
                  {image?.url && (
                    <div className="text-center extended-cards-block-image-holder">
                      <PrismicImgix
                        className="img-responsive img-responsive-height extended-cards-block-image"
                        src={image?.url}
                        alt={image?.alt}
                        desktop="450px"
                        mobile="150px"
                        tablet="120px"
                        largeDisplay="500px"
                      />
                    </div>
                  )}
                  {checkContentPresence(image_header) && (
                    <div className="mt-md-4 mt-2xl-4 mt-3 font-weight-bold extended-cards-block-title">
                      {textResolver(image_header)}
                    </div>
                  )}
                  {checkContentPresence(image_description) && (
                    <div className="mt-3 mt-2xl-3 extended-cards-block-text">
                      {textResolver(image_description)}
                    </div>
                  )}
                  {image_link?.url && (
                    <PrismicLinkTag
                      urlText={image_link_text}
                      url={image_link?.url}
                      target={image_link?.target}
                      className="text-uppercase font-weight-bold program-link extended-cards-block-link"
                    />
                  )}
                </div>
              )
            )}
          </Slider>
        </div>

        {link?.url && (
          <div className="mt-lg-5 mt-2xl-5 mt-md-4 mt-2 start-an-order-home-btn d-flex justify-content-center extended-cards-cta-row">
            <PrismicLinkTag
              urlText={link_text}
              url={link?.url}
              target={link?.target}
              className="sns-h5 text-uppercase font-weight-bold program-link"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExtendedCardsBlock;
